<template>
  <div>
    <header-elem />
    <navigation-elem />
    <banners-elem v-if="!isPropertiesPage && !isProperty" />
    <content-elem v-if="!isProperty" />
    <properties-elem v-if="isPropertiesPage" />
    <property-elem v-if="isProperty" />
    <maps-elem v-if="isContactPage" />
    <contact-form v-if="isProperty || isContactPage" />
    <testimonials-elem />
    <latest-elem />
    <footer-elem />

    <modal :scrollable="true" height="auto" name="valuation" width="90%">
      <a @click.prevent="$modal.hide('valuation')" class="modal-close" href>
        <font-awesome-icon icon="times" />
      </a>
      <div class="modal-content">
        <contact-form :modal="true" />
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import api from "@/services/api"

import ContactForm from "@/components/ContactForm.vue"
import HeaderElem from "@/components/Header.vue"
import BannersElem from "@/components/Banners.vue"
import ContentElem from "@/components/Content.vue"
import NavigationElem from "@/components/Navigation.vue"
import FooterElem from "@/components/Footer.vue"
import LatestElem from "@/components/Latest.vue"
import TestimonialsElem from "@/components/Testimonials.vue"
import TwitterElem from "@/components/Twitter.vue"
import AccreditationsElem from "@/components/Accreditations.vue"
import SearchElem from "@/components/SearchBar.vue"
import PropertiesElem from "@/components/Properties.vue"
import PropertyElem from "@/components/Property.vue"
import MapsElem from "@/components/Maps.vue"

var VueScrollTo = require("vue-scrollto")
var options = {
  container: "body",
  easing: "ease-in",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: function() {
    // scrolling started
  },
  onDone: function() {
    // scrolling is done
  },
  onCancel: function() {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  name: "page",
  components: {
    ContactForm,
    HeaderElem,
    ContentElem,
    BannersElem,
    NavigationElem,
    FooterElem,
    LatestElem,
    TestimonialsElem,
    TwitterElem,
    AccreditationsElem,
    SearchElem,
    PropertiesElem,
    PropertyElem,
    MapsElem
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage", "isProperty", "isPropertiesPage", "isContactPage"])
  },
  metaInfo() {
    return {
      title: this.page.title,
      meta: [
        { name: "description", content: this.page.meta_desc },
        { name: "keywords", content: this.page.meta_keywords }
      ]
    }
  },
  created: function() {
    var route = this.$route
    var url = route.params.url
    var promises = []
    var store = this.$store
    var state = this.$store.state

    if (!url) store.commit("setPage", {})

    if (route.name == "404") this.page = { main_text: "Sorry, this page cannot be found!" }

    if (route.name == "page-by-url") promises.push(api.getPageByURL(url))
    else if (route.name == "root") promises.push(api.getHomePage())
    else if (route.name == "our-developments") promises.push(state.propertiesPage)
    else if (route.name == "property") promises.push(api.getPageByItemID(route.params.id))

    Promise.all(promises).then(vals => {
      var returnedpage = vals[0]
      store.commit("setPage", returnedpage)

      if (!returnedpage || !returnedpage.ItemID)
        store.commit("setPage", { main_text: "Sorry, this page cannot be found!" })

      api
        .getPages("", "page.sub=@" + this.page.ItemID)
        .then(subs =>
          api
            .getPages("", "page.sub=@" + this.page.ParentID)
            .then(sibs => store.commit("setPageSubs", subs.concat(sibs)))
        )

      if (!this.isHomePage && (!this.page.banners || !this.page.banners.length))
        api.getPageByItemID(state.mortgagesID, "banners").then(home => this.$set(this.page, "banners", home.banners))

      this.$nextTick().then(() => {
        if (this.$route.hash) setTimeout(() => VueScrollTo.scrollTo(this.$route.hash, 500, options), 300)
      })
    })

    store.dispatch("getMisc")
    store.dispatch("getMainPages")
    store.dispatch("getProperties")
  }
}
</script>
